const inputDirectionChange = {
    // https://stackoverflow.com/questions/37371842/how-to-detect-hebrew-characters-in-a-string-in-javascript
    isHebrew: function(str) {
        if (typeof(str)==='undefined' || str.length === 0) {

            return true;
        }
        var pattern = /[\u0590-\u05FF]/;

        return pattern.test(str);
    },
    // https://stackoverflow.com/questions/4446244/how-to-check-if-any-arabic-character-exists-in-the-string-javascript
    isArabic: function(str) {
        if (typeof(str)==='undefined' || str.length === 0) {

            return true;
        }
        var pattern = /[\u0600-\u06FF\u0750-\u077F]/;

        return pattern.test(str);
    },
    isRtlText: function(str) {
        return inputDirectionChange.isArabic(str) || inputDirectionChange.isHebrew(str);
    },
    checkIfLtr: function(value, jQueryElement) {
        if (!value && !jQueryElement) {

            return;
        }
        if (inputDirectionChange.isArabic(value) || inputDirectionChange.isHebrew(value)) {
            inputDirectionChange.removeClass(jQueryElement);
        } else {
            inputDirectionChange.addClass(jQueryElement);
        }
    },
    addClass: function(jQueryElement) {
        if (!jQueryElement) {

            return;
        }
        jQueryElement.addClass('input-ltr');
        const parent = jQueryElement.get(0).parentElement.parentElement.parentElement;
        parent.classList.add('ltr');
    },
    removeClass: function(jQueryElement) {
        if (!jQueryElement) {

            return;
        }
        jQueryElement.removeClass('input-ltr');
        const parent = jQueryElement.get(0).parentElement.parentElement.parentElement;
        parent.classList.remove('ltr');
    },
    onChangeAction: function(jQuerySelector) {
        var jQueryElements = jQuery(jQuerySelector);
        if (jQueryElements.length === 0) {

            return;
        }

        if (window._d.isRTL) {
            jQueryElements.keyup(function(event) {
                const self = jQuery(event.target);
                const value = self ? self.val() : '';
                inputDirectionChange.checkIfLtr(value, self);
            });

            jQueryElements.focus(function(event) {
                const self = jQuery(event.target);
                const value = self ? self.val() : '';
                inputDirectionChange.checkIfLtr(value, self);
            });

            jQueryElements.each(function(i, obj) {
                const self = jQuery(obj);
                const value = self ? self.val() : '';
                inputDirectionChange.checkIfLtr(value, self);
            });
        }
    }
};
